export default {
    title: "Custom Events",
    empty_message: "You don't have any Events yet,",
    empty_action: "create the first one now!",
    new_event_button: "New Event",
    search_placeholder: "Search events...",
    no_results_found: 'No events found for "<strong>{0}</strong>".',
    clear_search: "Clear search",
    save_success: "Saved successfully",
    save_button: "Save",
    page_title: "Kevi | Custom Events",
    event_title_label: "Event Title",
    event_title_placeholder: "Event Title",
    cannot_edit_warning:
        "This event has one or more occurrences recorded in the system and cannot be removed or have its title changed.",
    registrations_count: "{0} event occurrence recorded",
    registrations_count_plural: "{0} event occurrences recorded",
    archive_event: "Archive event",
    remove_notice: 'The Event "{0}" will be removed upon saving.',
    undo: "Undo",
    register_event_button: "Register Event",
    register_event_title: "Register Event",
    search_event_placeholder: "Search event...",
    no_events_created: "No custom events created at the moment",
    create_event_button: "Create Event",
    register_confirmation_title: "Do you want to register the event?",
    register_confirmation_body:
        'This action is irreversible and will add the custom event <strong>"{0}"</strong> to this client\'s timeline.',
    register_success: "Custom event registered successfully!",
    register_error: "Error registering custom event.",
};
